// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".products-info__image{width:12.5rem;height:12.5rem}", ""]);
// Exports
module.exports = exports;
